module.exports = __webpack_public_path__ + "img/left_top_0.ef55178.png";